<template>
    <div class="clinics clinics--page">
        <div class="clinics__sidebar">
            <div class="clinics__filters">
                <div class="clinics__filtersgroup filter">
                    <h5 class="filter__name r-title">Название клиники</h5>
                    <div class="filter__items">
                        <div class="filter__item">
                            <el-input v-model="search"
                                      clearable
                                      placeholder="Поиск по названию"
                                      size="mini"/>
                        </div>
                    </div>
                </div>
                <div class="vets__filtersgroup filter">
                    <div class="filter__items">
                        <div class="filter__item">
                            <label class="toggle">
                                <input class="toggle__input screen-reader" type="checkbox" v-model="myCityClinics"
                                       :disabled="isLoaded">
                                <span class="toggle__label">
                                    <span class="toggle__text">
                                        Сначала клиники моего города
                                    </span>
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
                <template v-for="(item, key) in filter">
                    <div class="clinics__filtersgroup filter">
                        <h5 class="filter__name r-title">{{ item.title }}</h5>
                        <div class="filter__items">
                            <div class="filter__item">
                                <label class="toggle">
                                    <input type="checkbox" :ref="'all' + key" class="toggle__input screen-reader" @click="checkAll(filter[key], $event)"
                                           :disabled="isLoaded">
                                    <span class="toggle__label">
                                    <span class="toggle__text">
                                        Показать всех
                                    </span>
                                </span>
                                </label>
                            </div>
                            <div class="filter__item" v-for="element in item.elements">
                                <label class="toggle">
                                    <input class="toggle__input screen-reader" type="checkbox" @click="uncheckSelectAll(key)" v-model="element.checked"
                                           :disabled="isLoaded">
                                    <span class="toggle__label">
                                <span class="toggle__text">
                                    {{ element.title }}
                                </span>
                            </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="clinics__list">
            <a :href="'/clinics/' + clinic.slug" class="c-card r-link" v-for="clinic in clinics.data" @click="saveFilter()">
                <div class="c-card__intro">
                    <img :src="clinic.user.avatar" class="c-card__photo avatar" alt="#">
                    <span class="c-card__name">{{ clinic.user.name }}</span>
                    <span class="c-card__caption">{{ clinic.address }}</span>
                    <br>
                    <div class="v-card__caption" v-if="clinic.city">
                        <span>{{ clinic.city.title }}</span>
                    </div>
                </div>
                <div class="c-card__hover">
                    <div class="c-card__info">
                        <span class="c-card__info-name">Контакты:</span>
                        <span class="c-card__info-value">{{ clinic.phone }}</span>
                        <span class="c-card__info-value">{{ clinic.address }}</span>
                    </div>
                    <div class="c-card__info">
                        <span class="c-card__info-name">Режим работы:</span>
                        <span class="c-card__info-value">{{ clinic.work_schedule }}</span>
                    </div>
                </div>
            </a>
        </div>

        <div class="clinics__pagination pagination-block" v-if="clinics.total > clinics.per_page">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="clinics.total"
                :page-size="clinics.per_page"
                :current-page="clinics.current_page"
                @current-change="getClinics($event)">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import api from "../../../admin/api/api";

    export default {
        name: "Clinics",
        data: () => ({
            clinics: [],
            search: null,
            filter: [],
            countOnPage: 3,
            currentPage: 1,
            total: 1,
            authUserType: window.laravel.authUserType,
            city: window.laravel.city,
            isLoaded: false,
            roles: window.laravel.roles,
            testRole: window.laravel.testRole,
            myCityClinics: true,
        }),
        computed: {
            checked() {
                const checked = {};

                for (let key in this.filter) {
                    this.filter[key].elements.forEach((element) => {
                        if (element.checked) {
                            if (!checked[key])
                                checked[key] = [];

                            checked[key].push(element.id);
                        }
                    });
                }

                return checked;
            },
        },
        watch: {
            checked() {
                this.isLoaded = true;
                this.getClinics();
                sessionStorage.setItem('filterCheckboxClinics', JSON.stringify(this.filter));
            },
            myCityClinics() {
                this.getClinics();
            },
            search() {
                this.isLoaded = true;

                setTimeout(() => {
                    if (this.isLoaded) {
                        this.isLoaded = false;

                        this.getClinics();

                        sessionStorage.setItem('filterCheckboxClinics', JSON.stringify(this.filter));
                    }
                }, 1000);
            },
        },
        methods: {
            getClinics(page) {
                let authUserRoleTest = false;

                if(this.roles){
                    authUserRoleTest = !!this.roles.find(item => item.code === this.testRole);
                }

                let params = {
                    page,
                    appointmentTypes: this.filter['appointmentTypes']['elements'],
                    search: this.search,
                    authUserRoleTest: authUserRoleTest,
                    city: this.city,
                    myCityClinics: this.myCityClinics,
                };

                api.post('/api/clinic', params)
                    .then((response) => {
                        this.clinics = response.data;
                    }).catch((error) => {
                    this.$appNotify.error(error.response.data);
                }).finally(() => {
                    this.isLoaded = false;
                });
            },
            generateFilter() {
                return {
                    appointmentTypes: {
                        title: 'Тип записи',
                        elements: window.laravel.appointmentTypes,
                    },
                };
            },
            checkAll(item, event) {
                item.elements.forEach((element) => {
                    this.$set(element, 'checked', event.target.checked);
                });
            },
            uncheckSelectAll(key) {
                this.$refs['all' + key][0].checked = false;
            },
            pageCount: function () {
                return Math.ceil(this.clinics.length / this.countOnPage);
            },
            saveFilter() {
                sessionStorage.setItem('saveFilterClinics', true);
                sessionStorage.setItem('firstShow', true);
            }
        },
        created() {
            this.filter = this.generateFilter();
            sessionStorage.setItem('filterCheckbox', JSON.stringify(this.filter));

            let filterCheckboxClinics = JSON.parse(sessionStorage.getItem('filterCheckboxClinics'));
            let saveFilter = JSON.parse(sessionStorage.getItem('saveFilterClinics'));
            sessionStorage.setItem('saveFilterClinics', false);

            let uri = window.location.search;
            let uriParams = new URLSearchParams(uri);

            this.filter['appointmentTypes']['elements'].forEach((element, key) => {
                if(element.id === parseInt(uriParams.get("type"))) {
                    this.$set(element, 'checked', true);
                } else if (filterCheckboxClinics && filterCheckboxClinics['appointmentTypes'] && filterCheckboxClinics['appointmentTypes']['elements'][key]['checked'] && saveFilter){
                    this.$set(element, 'checked', true);
                }
            });
        }
    }
</script>
